import React from 'react';
import type { ActiveSideFiltersType } from '@fiverr-private/listing_types';
import { BI_SOURCES } from '../../../../../../utils/constants';
import { PillButton } from '../../../../pill_button';
import { navigateToCategory } from '../../utils/categoryNavigation';
import type { CategoryOption } from '../../FilterRow.types';

interface CategoryOptionPillProps {
    option: CategoryOption;
    activeFilters: ActiveSideFiltersType;
}

export const CategoryOptionPill = ({ option, activeFilters }: CategoryOptionPillProps) => {
    const onClick = () => {
        if (!option.selected) {
            navigateToCategory(option, activeFilters, BI_SOURCES.VISUAL_FILTERS);
        }
    };

    return (
        <PillButton isActive={!!option.selected} onClick={onClick}>
            {option.alias}
        </PillButton>
    );
};
